import { PickerProps } from '@react-native-picker/picker'
import { WithSpringConfig } from 'react-native-reanimated'

export const springConfig = {
  damping: 5,
  stiffness: 300,
  overshootClamping: true,
} satisfies WithSpringConfig

export const itemFontSize = 32
export const itemHeight = 380

export const itemStyle = {
  fontSize: itemFontSize,
  fontWeight: 'normal',
  height: itemHeight,
} satisfies PickerProps['itemStyle']
